import { Heart } from 'lucide-react';
import { Button } from '../../utils/Button';
import { useAddToFavorites } from '../../hooks/useAddToFavorites';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const AddFavourite = ({ product }) => {
  const { isFavourite, toggleFavourite, isLoading } =
    useAddToFavorites(product);

  if (!product || Object.keys(product).length === 0) return null;
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const handelRouteToLogin = () => {
    navigate('/login');
  };

  return (
    <Button
      onClick={!isAuthenticated ? handelRouteToLogin : toggleFavourite}
      aria-label={isFavourite ? 'Remove from favourite' : 'Add to favourite'}
      className="focus:outline-none"
      disabled={isLoading}
    >
      <span className="sr-only">
        {isFavourite ? 'Remove from favourite' : 'Add to favourite'}
      </span>
      <Heart
        size={18}
        cursor="pointer"
        fill={isFavourite ? 'red' : 'white'}
        aria-hidden="true"
      />
    </Button>
  );
};
